import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import type { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Icon from 'tbk-components/src/components/Icon';
import Button from 'tbk-components/src/components/Button';
import { colorMap, accentColors } from '../../utils';

export interface ISliderItemProps extends IBaseElementProps {
	link?: ILink;
	image?: IImage;
	/**
	 * Icon to display in top left.
	 * Shown if no image is provided.
	 */
	icon?: 'download' | 'search' | 'pencil-line' | 'check-square' | 'login' | 'map-pin' | 'map' | 'video' | 'warning' | 'route' | 'people' | undefined | null;
	/**
	 * @noUI
	 */
	itemBackgroundColor?: accentColors;
	/**
	 * @noUI
	 */
	altLayout?: boolean;
}

const SliderItem: React.FC<ISliderItemProps> = ({
	itemBackgroundColor,
	className,
	classNames = [],
	icon,
	image,
	link,
	altLayout,
}) => (
	<a
		{...link}
		className={
			className ||
			cn(
				'slider-item',
				itemBackgroundColor &&
					`slider-item--bg-${colorMap[itemBackgroundColor]}`,
				altLayout && 'slider-item--alt',
				...classNames,
			)
		}
	>
		{image && <Image {...image} />}

		<div
			className={cn(
				'slider-item__content',
				!image && 'slider-item__content--no-image',
			)}
		>
			{icon && !image && <Icon name={icon} />}
			{link?.label && <h3>{link.label}</h3>}
			{image && !altLayout && (
				<span
					className="btn btn-primary btn-md"
				>
					<i className="icon icon-arrow-right" />
				</span>
			)}
		</div>
	</a>
);

export default SliderItem;
